import {
  CART_CHANGE_FAILURE,
  CART_ERROR,
  CART_IS_LOADING,
  CART_RESET_STATE,
  PIN_IS_VALID,
  RECEIVE_CART_ITEMS,
  RECEIVE_CART_PROMOS,
  RECEIVE_PIN,
  RECEIVE_TRACKING_NUMBER,
  REQUEST_CART_UPDATE,
  SHOW_CART_MODAL,
  UPDATE_CART_COUNT
} from 'constants/reduxActions';

const initialState = { isLoaded: false, cartObj: {}, cartCount: null, error: null };

export default function cart(state = initialState, action) {
  const { type, cartObj, error, promos, isShowing, stockId, cartCount, pin, isValid, trackingNumber } = action;

  switch (type) {
    case RECEIVE_CART_ITEMS:
      return { ...state, cartObj, cartCount, isLoaded: true, loading: false };
    case RECEIVE_CART_PROMOS:
      return { ...state, promos };
    case UPDATE_CART_COUNT:
      return { ...state, cartCount };
    case REQUEST_CART_UPDATE:
      return { ...state, loading: true, error: null };
    case CART_CHANGE_FAILURE:
      return { ...state, loading: false };
    case CART_ERROR:
      return { ...state, error };
    case CART_IS_LOADING:
      return { ...state, loading: true };
    case SHOW_CART_MODAL: {
      return { ...state, isModalShowing: isShowing, addedStockId: isShowing && stockId };
    }
    case RECEIVE_PIN: {
      return { ...state, pin };
    }
    case PIN_IS_VALID: {
      return { ...state, isValid };
    }
    case RECEIVE_TRACKING_NUMBER: {
      return { ...state, trackingNumber };
    }
    case CART_RESET_STATE: {
      return initialState;
    }
    default:
      return state;
  }
}
